<script>
import { counterMixin } from '@mixins/counter-mixin';

export default {
  components: {},
  props: {
    workout: {
      type: Object,
      required: true,
      default: null,
    },
    mini: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      placeholder: require('@assets/images/placeholder-photo-upload.svg'),
    };
  },
  mixins: [counterMixin],
  computed: {
    hasWorkoutMetaData() {
      return (
        (this.workout &&
          this.workout.muscleGroups &&
          this.workout.muscleGroups.length) ||
        (this.workout.exerciseDifficulty &&
          this.workout.exerciseDifficulty.exerciseDifficulty_id)
      );
    },
    hasMuscleGroups() {
      return (
        this.workout &&
        this.workout.muscleGroups &&
        this.workout.muscleGroups.length
      );
    },
    duration() {
      const seconds = this.workout.timeToComplete;
      const unit = this.$_getTimeUnit(seconds);
      const formattedTime = this.$_getFormattedSeconds(seconds);
      return `${formattedTime} ${unit}`;
    },
    coverPhoto() {
      return this.workout &&
        this.workout.mediaAssets &&
        this.workout.mediaAssets.coverPhoto &&
        this.workout.mediaAssets.coverPhoto.url
        ? this.workout.mediaAssets.coverPhoto.url
        : '';
    },
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div :class="['hero-workout-minimal', { mini: mini }]">
    <div
      :class="['hero-image-wrapper', { noPhoto: coverPhoto === '' }]"
      :style="[{ 'background-image': `url(${coverPhoto})` }]"
    >
      <span class="tags-wrapper">
        <div v-if="hasWorkoutMetaData" class="meta-tag">
          <template v-if="hasMuscleGroups">
            <span v-for="(group, i) in workout.muscleGroups" :key="i">
              {{ group.label
              }}<span v-if="i + 1 < workout.muscleGroups.length">,</span>
            </span>
          </template>
          <span v-if="workout.exerciseDifficulty">
            / {{ workout.exerciseDifficulty.label }}
          </span>
        </div>
        <div v-if="duration" class="meta-tag">
          <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-stopwatch'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 0h6v2H6V0zm2 13V7h2v6H8zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 009 3a9 9 0 00-9 9c0 4.97 4.02 9 9 9a8.994 8.994 0 007.03-14.61zM2 12c0 3.87 3.13 7 7 7s7-3.13 7-7-3.13-7-7-7-7 3.13-7 7z" fill="#000"/></svg>
          {{ duration ? duration : '' }}
        </div>
      </span>

      <div class="hero-title-wrapper" v-if="mini">
        <h1>{{ workout.label }}</h1>
      </div>
    </div>
    <div class="hero-title-wrapper" v-if="!mini">
      <h1>{{ workout.label }}</h1>
      <p v-if="workout.description">
        {{ workout.description }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.hero-workout-minimal {
  .hero-image-wrapper {
    align-items: flex-start;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    height: 39rem;
    justify-content: space-between;
    padding: 1.6rem;
    width: 100%;

    &.noPhoto {
      height: 4rem;
    }

    .tags-wrapper {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .meta-tag {
        background-color: rgba($color-black-wo-rgb, 0.5);
        border-radius: $base-border-radius;
        color: white;
        font-size: 1.2rem;
        font-weight: 800;
        letter-spacing: 0.1px;
        line-height: 2.2rem;
        padding: 0.5rem 1rem;
        text-transform: uppercase;
      }
    }

    .icon-stopwatch {
      margin-right: 0.5rem;
      width: 1.4rem;

      path {
        fill: white;
      }
    }
  }

  .hero-title-wrapper {
    padding: 3rem;
  }

  &.mini {
    height: 15.6rem;

    .hero-image-wrapper {
      background-position: bottom;
      background-size: cover;
      display: flex;
      flex-direction: column;
      height: 15.6rem;
      overflow: hidden;
      position: relative;

      &::before {
        background-color: $color-dark-gray-one;
        bottom: 0;
        content: '';
        left: 0;
        mix-blend-mode: multiply;
        opacity: 0.8;
        position: absolute;
        right: 0;
        top: 0;
      }
    }

    .hero-title-wrapper {
      padding: 3rem 0 0;
      position: relative;
      z-index: 1;

      h1 {
        color: white;
        font-size: 3.2rem;
        font-weight: 900;
        letter-spacing: -0.571429px;
        line-height: 3.8rem;
      }
    }

    .tags-wrapper {
      display: flex;
      justify-content: space-between;
      position: relative;
      width: 100%;
      z-index: 1;

      .meta-tag {
        background-color: transparent;
        padding: 0;
      }
    }
  }
}
</style>
